var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InterForm',{on:{"querySubmit":_vm.queryHandler}}),_c('InterBtnBox',{attrs:{"printBusinessType":1},on:{"overEmit":_vm.getDataSource}}),_c('InterList',{attrs:{"dataSource":_vm.dataSource,"printBusinessType":1},on:{"overEmit":_vm.getDataSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }